var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeSolid = function SvgHomeSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 2.594-.719.687-13 13L3.72 17.72 5 16.437V28h9V18h4v10h9V16.438l1.281 1.28 1.438-1.437-13-13Zm0 2.844 9 9V26h-5V16h-8v10H7V14.438Z"
  })));
};
export default SvgHomeSolid;